import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { cookieAttributes } from "util/resumeCookieSettings";
import { Breadcrumbs } from "features/breadcrumb/breadcrumbs";
import classes from "../Dashboard.module.scss";
import { DashboardsEmbedWrapper } from "../DashboardVisualization/dashboardEmbed";

function HealthServiceDemandPage(props) {
  const dashboardId = props?.match?.params?.dashboardId?.trim();

  const breadCrumbsItems = [
    { label: "Home", to: "/" },
    { label: "Health Service Demand" }
  ];

  useEffect(() => {
    if (dashboardId) {
      async function setResumeCookie() {
        const cookieValue = encodeURIComponent(
          `Health Service Demand - /healthservicedemand/${dashboardId}`
        );
        const resumeCookie = Object.assign(
          cookieAttributes(),
          { name: "platform_resume" },
          { value: cookieValue }
        );
        await cookieStore.set(resumeCookie);
      }
      setResumeCookie();
    }
  }, [dashboardId]);

  return (
    <div className={`query-wrapper ${classes["dashboard-wrapper"]}`}>
      <Breadcrumbs items={breadCrumbsItems} />
      <div className={classes["head-wrapper"]}>
        <div>
          <h3 className={classes["heading"]}>Health Service Demand</h3>
          <span className={classes["subtitle"]}>
            Assess future care needs through geographic, demographic, and care
            delivery trends.
          </span>
        </div>
      </div>
      <div>
        {dashboardId ? (
          <DashboardsEmbedWrapper dashboardId={dashboardId} />
        ) : (
          <div className="alert alert-warning">No dashboard specified</div>
        )}
      </div>
    </div>
  );
}

HealthServiceDemandPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

export default HealthServiceDemandPage;
